import * as React from 'react'

import { cn } from '@/styles/index'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'text-14 sm:text-16 w-full min-w-0 bg-transparent py-4 pr-12 pl-4 transition-[color,box-shadow] outline-none placeholder:text-[#BEC7DC] placeholder:capitalize disabled:cursor-not-allowed disabled:opacity-50 sm:h-36 sm:p-0 sm:px-12 sm:pb-0',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
